// imports
import React from 'react';
import HeroCollectionList from '../../molecules/list/heroCollection';

// exports
export default function HeroCollection(): JSX.Element {
  return <HeroCollectionList />;
}
